export const questions = {
  WITH_COMPANION: 'withCompanion',
  WITH_GUIDE_DOG: 'withGuideDog',
  OLDER_THAN_TWELVE: 'olderThanTwelve',
  COMPANION_WHEELCHAIR_SPACE: 'companionWheelchairSpace'
};
